import { Navigate, useLocation, useSearchParams } from "react-router-dom";

/** Legacy /settings/account → /settings?tab=profile#change-password */
export default function SettingsAccountRedirect() {
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const flow = searchParams.get("flow");
  const params = new URLSearchParams();
  params.set("tab", "profile");
  if (flow?.trim()) params.set("flow", flow.trim());
  const dest = `/settings?${params.toString()}#change-password`;
  return <Navigate to={dest} replace state={location.state} />;
}
